// BuscarempleadooModal.js (Actualizado)

import React, { useState, useEffect, useRef } from 'react';
import './BuscarEmpleadoModal.css';
import PuenteApi from '../../../../pageauth/PuenteApi';
import Mensaje from '../../../../Mensaje';

const HEADER_HEIGHT = 30;

const BuscarEmpleadoModal = ({ isVisible, onClose, onSelectempleado }) => {
    const { SetMensaje } = Mensaje();
    const {ObtenerEmpleados} = PuenteApi();

    const [empleadosLista, setEmpleadosLista] = useState([
        { nombre: 'Cargando Empleados...', id: 0 },
    ]);

    const [searchTerm, setSearchTerm] = useState('');
    const [filterType, setFilterType] = useState('nombre'); 
    const [filteredEmpleados, setFilteredEmpleados] = useState(empleadosLista);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const searchInputRef = useRef(null);

    useEffect(() => {
        const lowerCaseSearch = searchTerm.toLowerCase();
        
        const results = empleadosLista.filter(p => {
            if (filterType === 'nombre') {
                return p.nombre.toLowerCase().includes(lowerCaseSearch);
            }
            return false;
        });

        setFilteredEmpleados(results);
        setSelectedIndex(0);
    }, [searchTerm, filterType]);

    useEffect(() => {
        if (isVisible && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [isVisible]);

    const handleSelect = (empleado) => {
        const empleadooParaFactura = {
            nombre: empleado.nombre,
            nombre_solo: empleado.nombre_solo,
            apellido_solo: empleado.apellido_solo,
            id: empleado.id, 
        };
        setSearchTerm('');
        onSelectempleado(empleadooParaFactura);
        onClose();
    };

    const handleConfirm = () => {
        if (filteredEmpleados.length > 0) {
            setSearchTerm('');
            handleSelect(filteredEmpleados[selectedIndex]);
        }
    };
    
    const tablaRef = useRef(null);
    const scrollInstructionRef = useRef('nearest');


    const handleKeyDown = (event) => {
        event.stopPropagation();
        if (event.key === 'Escape') {
            onClose();
            return;
        }

        if (filteredEmpleados.length === 0) return;

        // Usamos la forma funcional de setSelectedIndex para obtener el valor más fresco
        setSelectedIndex(prevIndex => {
            let newIndex = prevIndex;

            if (event.key === 'ArrowDown') {
                event.preventDefault();
                scrollInstructionRef.current = 'end'; // Registrar movimiento hacia abajo
                newIndex = Math.min(prevIndex + 1, filteredEmpleados.length - 1);
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                scrollInstructionRef.current = 'start'; // Registrar movimiento hacia arriba
                newIndex = Math.max(prevIndex - 1, 0);
            } else if (event.key === 'Enter') {
                event.preventDefault();
                handleConfirm();
                return prevIndex;
            }

            return newIndex;
        });
    };

    const handleClick = (index) => {
        scrollInstructionRef.current = 'nearest'; // Un click es neutro o 'nearest'
        setSelectedIndex(index);
    };

    useEffect(() => {
        const container = tablaRef.current; 
        
        if (!container || filteredEmpleados.length === 0 || !isVisible) return;
        
        const selectedRow = container.children[selectedIndex];

        if (selectedRow) {
            
            // 1. Usa scrollIntoView para asegurar que el elemento esté visible
            selectedRow.scrollIntoView({
                behavior: 'smooth',
                block: scrollInstructionRef.current === 'start' ? 'start' : 'nearest', // Al subir, forzamos 'start'
            });

            if (scrollInstructionRef.current === 'start') {
                const newScrollTop = selectedRow.offsetTop - HEADER_HEIGHT;
            }
            scrollInstructionRef.current = 'nearest';
        }
        
    }, [selectedIndex, isVisible]);

    useEffect(() => {
        if (isVisible) {
            // Se usa window para capturar eventos en todo el modal
            window.addEventListener('keydown', handleKeyDown);
            return () => window.removeEventListener('keydown', handleKeyDown);
        }
    }, [isVisible, filteredEmpleados.length, handleConfirm, onClose]);

    // useEffect(() => {
    //     if (isVisible) {
    //         window.addEventListener('keydown', handleKeyDown);
    //         return () => window.removeEventListener('keydown', handleKeyDown);
    //     }
    // }, [isVisible, filteredEmpleados, selectedIndex, filterType]); 

    const obtenerEmpleados2 = async () => {
        try {
            const response = await ObtenerEmpleados();
            if (response && Array.isArray(response) && response.length > 0) {
                const empleados = response.map((empleado) => ({
                    nombre: empleado.nombre + ' ' + empleado.apellido, 
                    nombre_solo: empleado.nombre,
                    apellido_solo: empleado.apellido,
                    id: empleado.id,
                }));
                setEmpleadosLista(empleados);
                setFilteredEmpleados(empleados);
            } else {
                SetMensaje("Error", "No se encontraron empleados", 3000);
                setEmpleadosLista([{ nombre: 'Error al cargar empleados', id: 0 }]);
                setFilteredEmpleados([{ nombre: 'Error al cargar empleados', id: 0 }]);
            }
        } catch (error) {
            SetMensaje("Error", "Hubo un problema con la solicitud de empleados " + error, 3000);
        }
    };

    // Usamos useEffect para obtener los productos al montar el componente
    useEffect(() => {
            if(isVisible){
                setSearchTerm('');
                obtenerEmpleados2();
                setSelectedIndex(0);
            }
    }, [isVisible]); // Dependencias vacías para que solo se ejecute al montar el componente

    if (!isVisible) return null;

    return (
        <div className="modal-overlay-empleadoo">
            <div className="modal-content-empleadoo">
                
                <div className="modal-header-empleadoo">
                    <div className="buscador-empleadoo-filtro">
                        <label>FILTRAR POR</label>
                        <select 
                            className="select-filtro" 
                            value={filterType}
                            onChange={(e) => setFilterType(e.target.value)}
                        >
                            <option>Nombre</option>
                        </select>
                    </div>
                    
                    <div className="buscador-empleadoo-input">
                        <input
                            ref={searchInputRef}
                            type="text"
                            placeholder={`Buscar por ${filterType}...`}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
                
                {/* TABLA DE empleadoOS */}
                <div className="tabla-empleadoo">
                    <div className="encabezado-tabla-empleadoo">
                        <div>Nombre del empleado</div>
                    </div>

                    <div className="filas-empleadoo" ref={tablaRef}>
                        {filteredEmpleados.map((p, i) => (
                            <div
                                key={p.codigo}
                                className={`fila-empleadoo ${i === selectedIndex ? 'seleccionado' : ''}`}
                                onDoubleClick={() => handleSelect(p)}
                                onClick={() => setSelectedIndex(i)}
                            >
                                <div>{p.nombre}</div>
                            </div>
                        ))}
                        
                        {filteredEmpleados.length === 0 && (
                            <div className="fila-empleadoo-vacia">No se encontraron empleadoos.</div>
                        )}
                    </div>
                </div>

                <div className="modal-footer-empleadoo">
                    <div className="total-registros">
                        Total: {filteredEmpleados.length} registros disponibles
                    </div>
                    
                    {/* Botón de Cancelar */}
                    <button className="boton-cancelar-empleadoo" onClick={onClose}>
                        ❌ Cancelar
                    </button>
                    
                    {/* Botón de Ok */}
                    <button className="boton-ok-empleadoo" onClick={handleConfirm}>
                        ✅ Ok
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BuscarEmpleadoModal;